function boardStatusAlertDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/board-status-alert/board-status-alert-dialog.html?$$REVISION$$'
  }
}

export { boardStatusAlertDialogDirective }
